function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m6 32h26v26h-26z",
  fill: "#a67c52"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m32 32h26v26h-26z",
  fill: "#8c6239"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m15 6h26v26h-26z",
  fill: "#c69c6d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m24 6v7l2-2 2 2 2-2 2 2v-7z",
  fill: "#a67c52"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m15 32v7l2-2 2 2 2-2 2 2v-7z",
  fill: "#8c6239"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m41 32v7l2-2 2 2 2-2 2 2v-7z",
  fill: "#c69c6d"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#29485a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9 41h5v2h-5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9 45h7v2h-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35 41h6v2h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35 45h9v2h-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18 15h3v2h-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18 19h9v2h-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24 50h4v4h-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50 50h4v4h-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33 24h4v4h-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2 57h60v2h-60z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m59 32a1 1 0 0 0 -1-1h-16v-25a1 1 0 0 0 -1-1h-26a1 1 0 0 0 -1 1v25h-8a1 1 0 0 0 -1 1v25h-3v2h60v-2h-3zm-17 1h6v3.586l-.293-.293a1 1 0 0 0 -1.414 0l-1.293 1.293-1.293-1.293a1 1 0 0 0 -1.414 0l-.293.293zm-11-26v3.586l-.293-.293a1 1 0 0 0 -1.414 0l-1.293 1.293-1.293-1.293a1 1 0 0 0 -1.414 0l-.293.293v-3.586zm-15 0h7v6a1 1 0 0 0 1.707.707l1.293-1.293 1.293 1.293a1 1 0 0 0 1.414 0l1.293-1.293 1.293 1.293a1 1 0 0 0 1.707-.707v-6h7v24h-24zm0 26h6v3.586l-.293-.293a1 1 0 0 0 -1.414 0l-1.293 1.293-1.293-1.293a1 1 0 0 0 -1.414 0l-.293.293zm-9 0h7v6a1 1 0 0 0 1.707.707l1.293-1.293 1.293 1.293a1 1 0 0 0 1.414 0l1.293-1.293 1.293 1.293a1 1 0 0 0 1.707-.707v-6h7v24h-24zm26 24v-24h7v6a1 1 0 0 0 1.707.707l1.293-1.293 1.293 1.293a1 1 0 0 0 1.414 0l1.293-1.293 1.293 1.293a1 1 0 0 0 1.707-.707v-6h7v24z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m9 41h5v2h-5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m9 45h7v2h-7z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m35 41h6v2h-6z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m35 45h9v2h-9z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m18 15h3v2h-3z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m18 19h9v2h-9z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m28 49h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m54 49h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m33 29h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1zm1-4h2v2h-2z"
});

var SvgInventory = function SvgInventory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInventory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inventory.5cc7f150.svg";
export { ForwardRef as ReactComponent };